import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { Button } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  className?: string;
}

const PodiumQRButton: React.FC<IParams> = ({ className }) => {
  const rootStore = useContext(RootStoreContext);
  const { showQRCode } = rootStore.podiumStore;

  return (
    <>
      <div className={className}>
        <Button color="" className="podium-generic-btn" onClick={showQRCode}>
          <i className="fas fa-3x fa-qrcode"></i>
        </Button>
      </div>
    </>
  );
};

export default observer(PodiumQRButton);
